<template>
  <div
    class="add_step_all flex flex--content--center"
    :class="'add_step_all--count-' + stepsNumber"
  >
    <div
      v-for="step in stepsNumber"
      :key="step"
      class="add_step"
      :class="{ active: currentStep >= step }"
    >
      {{ step }}
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Steps",
  computed: {
    ...mapState("Surgery", ["currentStep"]),
    ...mapGetters("Surgery", ["stepsNumber"])
  }
};
</script>
